// These polyfills are in addition to the core js polyfills that Babel adds
// automatically!

if (!('IntersectionObserver' in window)) {
  import(
    /* webpackChunkName: "polyfill-intersectionobserver" */ 'intersection-observer'
    // eslint-disable-next-line no-console
  ).then(() => console.log('IntersectionObserver polyfill loaded'));
}
